export default __webpack_public_path__ + "static/media/Frame7.d902bf30.png";